/**
 * Enum for the target of a link
 */
export enum LinkTarget {
  Blank = '_blank',
}
